import { render, staticRenderFns } from "./SpecialSuit.vue?vue&type=template&id=12ef0bde&scoped=true"
import script from "./SpecialSuit.vue?vue&type=script&lang=js"
export * from "./SpecialSuit.vue?vue&type=script&lang=js"
import style0 from "./SpecialSuit.vue?vue&type=style&index=0&id=12ef0bde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ef0bde",
  null
  
)

export default component.exports